import React, { useMemo } from "react"
import { getMainCustomer } from "utils"

const CustomerLogo = () => {
  const { logo, customerName } = useMemo(() => {
    const mainCustomer = getMainCustomer()
    const mainCustomerLogo = mainCustomer?.logo
    return {
      logo: mainCustomerLogo?.path || "",
      customerName: mainCustomer?.name,
    }
  }, [])

  return (
    <div className="btn header-item noti-icon d-flex align-items-center">
      <img
        src={logo}
        alt={`${customerName} logo`}
        className="customer-logo"
        height={30}
      />
    </div>
  )
}

export default CustomerLogo
